import en from './locales/en';

export default {
  en,
};
